"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = IconMoreVertical;

var _react = _interopRequireDefault(require("react"));

var _style = _interopRequireDefault(require("../style"));

var _ref =
/*#__PURE__*/
_react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("circle", {
  cx: "12",
  cy: "12",
  r: "2"
}), _react["default"].createElement("circle", {
  cx: "12",
  cy: "5",
  r: "2"
}), _react["default"].createElement("circle", {
  cx: "12",
  cy: "19",
  r: "2"
})));

function IconMoreVertical(props) {
  return _react["default"].createElement("svg", {
    style: props.customStyle || _style["default"],
    className: props.className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none",
    preserveAspectRatio: "xMaxYMid slice",
    focusable: "false",
    "data-cabanaico": true
  }, _ref);
}